import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const SMALL_HORIZONTAL_MARGIN = 0.5;
const SMALL_VERTICAL_MARGIN = 8;

const IMAGE_SIZES_PER_BREAKPOINT = {
  XL: 600,
  L: 600,
  M: 400,
  S: 300,
};

const getImageWidthInPixels = (doubleSized: boolean, breakpoint: keyof typeof IMAGE_SIZES_PER_BREAKPOINT) => {
  const imageSize = IMAGE_SIZES_PER_BREAKPOINT[breakpoint];

  if (breakpoint === "XL") {
    return imageSize;
  }

  return doubleSized ? imageSize * 2 : imageSize;
};

const style = () => {
  const { space1, space4 } = theme();

  const largeHorizontalMargin = space1 / 2;

  return StyleSheet.create({
    contentContainer: {
      flex: 1,
    },
    fullWidthBanner: {
      paddingHorizontal: SMALL_HORIZONTAL_MARGIN,
      paddingVertical: SMALL_VERTICAL_MARGIN,
      width: "100%",
    },
    fullWidthItem: {
      paddingHorizontal: SMALL_HORIZONTAL_MARGIN,
      paddingVertical: SMALL_VERTICAL_MARGIN,
      width: "100%",
    },
    halfWidthBanner: {
      paddingBottom: space4,
      paddingHorizontal: largeHorizontalMargin,
      width: "50%",
    },
    halfWidthItem: {
      paddingHorizontal: SMALL_HORIZONTAL_MARGIN,
      paddingVertical: SMALL_VERTICAL_MARGIN,
      width: "50%",
    },
    item: {
      paddingBottom: space4,
      paddingHorizontal: largeHorizontalMargin,
      width: "25%",
    },
    layout: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
    list: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
    space8mall: {
      marginHorizontal: -SMALL_HORIZONTAL_MARGIN,
    },
  });
};

export { style, getImageWidthInPixels };
